































import Vue from "vue";
import Tooltip from "@/components/tooltip/Tooltip.vue";
import { formatPrice } from "@/filters/format-price";
import { Util } from "@/util/util";
import { ExchangeRates } from "@/model/exchange-rates";

export default Vue.extend({
  name: "PrettyPrice",
  components: {
    Tooltip
  },
  props: {
    price: {
      type: Number,
      default: 0,
      required: true
    },
    strike: {
      type: Boolean,
      default: false
    },
    toneDown: {
      type: Boolean,
      default: false
    },
    discountHighlight: {
      type: Boolean,
      default: false
    },
    priceOnRequest: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
  },
  computed: {

    exchangeRate(): ExchangeRates {
      return Util.getExchangeRate();
    },

    currencyPrice(): number {
      if ('EUR' === this.exchangeRate.currency) {
        return this.price;
      } else {
        return this.exchangeRate.exchangeRate * this.price;
      }
    },

    integerPart(): string {
      const formattedPriceParts = formatPrice(this.currencyPrice, false).split(",");
      return parseInt(formattedPriceParts[0], 10).toString(10);
    },
    decimalPart(): string {
      const formattedPriceParts = formatPrice(this.currencyPrice, false).split(",");
      return parseInt(formattedPriceParts[1], 10).toString(10).padStart(2, '0');
    }
  }
});
